import { render, staticRenderFns } from "./Goodselector.vue?vue&type=template&id=57cf5061&scoped=true"
import script from "./Goodselector.vue?vue&type=script&lang=js"
export * from "./Goodselector.vue?vue&type=script&lang=js"
import style0 from "./Goodselector.vue?vue&type=style&index=0&id=57cf5061&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf5061",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57cf5061')) {
      api.createRecord('57cf5061', component.options)
    } else {
      api.reload('57cf5061', component.options)
    }
    module.hot.accept("./Goodselector.vue?vue&type=template&id=57cf5061&scoped=true", function () {
      api.rerender('57cf5061', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchase/components/common/Goodselector.vue"
export default component.exports